import React from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import FeedbackTabButtonsViewModel from "../ViewModels/FeedbackTabButtonsViewModel";

interface IProps {
    feedback: FeedbackTabButtonsViewModel
}

export default function FeedbackTabDetailsSection(props: IProps) {
    return (
        <Grid container spacing={1}>
            <Grid size={6}>
                <Typography>Monitor Name: {props.feedback.monitorName}</Typography>
            </Grid>
            <Grid size={6}>
                <Typography>Agent Name: {props.feedback.agentName}</Typography>
            </Grid>
            <Grid size={6}>
                <Typography>Date Monitored: {props.feedback.dateMonitored}</Typography>
            </Grid>
            <Grid size={6}>
                <Typography>Result: {props.feedback.result}</Typography>
            </Grid>
            <Grid size={6}>
                <Typography>Status: {props.feedback.status}</Typography>
            </Grid>
        </Grid>
    )
}